/**
 * Syncanix brand mark vector data — the single source of truth for the two
 * gradient paths and the brand gradient stops, lifted verbatim from the design
 * bundle (`Syncanix Logo.html` / `logo-data.js`, `assets/syncanix-*.svg`).
 *
 * The mark is two chasing blades inside a chat bubble; both render from the
 * same cyan→blue→violet gradient. `Logo` and `BrandLoader` both consume these
 * constants so the silhouette never drifts between the static and animated mark.
 */

/** Outer blade (P0). */
export const PATH_OUTER =
  'M605.0 282.0 C619.0 281.0 634.8 281.0 649.0 282.0 C663.2 283.0 676.8 285.2 690.0 288.0 C703.2 290.8 714.7 294.0 728.0 299.0 C741.3 304.0 753.7 308.2 770.0 318.0 C786.3 327.8 811.7 346.0 826.0 358.0 C840.3 370.0 846.5 378.0 856.0 390.0 C865.5 402.0 875.0 415.7 883.0 430.0 C891.0 444.3 898.5 461.0 904.0 476.0 C909.5 491.0 913.2 506.8 916.0 520.0 C918.8 533.2 920.2 541.3 921.0 555.0 C921.8 568.7 922.2 586.7 921.0 602.0 C919.8 617.3 917.7 631.7 914.0 647.0 C910.3 662.3 904.0 681.0 899.0 694.0 C894.0 707.0 890.5 714.0 884.0 725.0 C877.5 736.0 868.0 748.3 860.0 760.0 C849.0 741.7 841.7 724.7 827.0 705.0 C812.3 685.3 790.2 660.2 772.0 642.0 C753.8 623.8 742.5 614.7 718.0 596.0 C693.5 577.3 656.0 552.0 625.0 530.0 C625.0 528.7 625.0 527.3 625.0 526.0 C627.3 525.7 604.0 519.8 632.0 525.0 C660.0 530.2 739.3 546.3 793.0 557.0 C791.7 548.3 791.8 540.3 789.0 531.0 C786.2 521.7 780.8 509.8 776.0 501.0 C771.2 492.2 767.2 486.2 760.0 478.0 C752.8 469.8 743.3 459.8 733.0 452.0 C722.7 444.2 708.7 436.2 698.0 431.0 C687.3 425.8 678.0 423.3 669.0 421.0 C660.0 418.7 654.3 417.5 644.0 417.0 C633.7 416.5 617.0 417.0 607.0 418.0 C597.0 419.0 594.0 419.7 584.0 423.0 C574.0 426.3 557.2 432.8 547.0 438.0 C536.8 443.2 532.0 446.5 523.0 454.0 C514.0 461.5 503.0 473.3 493.0 483.0 C480.7 463.7 467.2 445.0 456.0 425.0 C444.8 405.0 436.0 383.7 426.0 363.0 C427.0 361.0 421.8 363.0 429.0 357.0 C436.2 351.0 454.8 335.8 469.0 327.0 C483.2 318.2 498.0 310.5 514.0 304.0 C530.0 297.5 549.8 291.7 565.0 288.0 C580.2 284.3 591.0 283.0 605.0 282.0 Z';

/** Inner blade (P1). */
export const PATH_INNER =
  'M387.0 406.0 C398.3 426.0 408.5 447.3 421.0 466.0 C433.5 484.7 446.0 500.7 462.0 518.0 C478.0 535.3 491.2 549.3 517.0 570.0 C542.8 590.7 583.7 618.0 617.0 642.0 C616.7 643.7 616.3 645.3 616.0 647.0 C613.7 647.0 635.0 652.2 609.0 647.0 C583.0 641.8 509.7 626.3 460.0 616.0 C460.7 622.3 459.3 626.2 462.0 635.0 C464.7 643.8 470.3 658.5 476.0 669.0 C481.7 679.5 489.3 689.8 496.0 698.0 C502.7 706.2 508.7 711.8 516.0 718.0 C523.3 724.2 530.5 729.7 540.0 735.0 C549.5 740.3 560.8 746.2 573.0 750.0 C585.2 753.8 600.8 756.8 613.0 758.0 C625.2 759.2 636.0 758.2 646.0 757.0 C656.0 755.8 663.0 754.3 673.0 751.0 C683.0 747.7 696.5 742.0 706.0 737.0 C715.5 732.0 721.2 728.3 730.0 721.0 C738.8 713.7 749.3 702.3 759.0 693.0 C771.0 710.0 783.8 726.3 795.0 744.0 C806.2 761.7 815.7 780.7 826.0 799.0 C807.7 812.7 785.5 830.5 771.0 840.0 C756.5 849.5 750.0 851.3 739.0 856.0 C728.0 860.7 721.0 864.3 705.0 868.0 C689.0 871.7 661.8 876.7 643.0 878.0 C624.2 879.3 606.3 877.5 592.0 876.0 C577.7 874.5 568.7 871.3 557.0 869.0 C533.7 878.7 505.8 891.3 487.0 898.0 C468.2 904.7 456.8 906.7 444.0 909.0 C431.2 911.3 421.3 911.0 410.0 912.0 C409.7 910.3 409.3 908.7 409.0 907.0 C416.7 891.3 427.2 872.2 432.0 860.0 C436.8 847.8 436.8 842.2 438.0 834.0 C439.2 825.8 438.7 818.7 439.0 811.0 C425.0 795.7 409.8 782.0 397.0 765.0 C384.2 748.0 371.3 728.0 362.0 709.0 C352.7 690.0 346.0 670.3 341.0 651.0 C336.0 631.7 333.3 609.8 332.0 593.0 C330.7 576.2 331.2 565.8 333.0 550.0 C334.8 534.2 337.7 516.0 343.0 498.0 C348.3 480.0 357.7 457.3 365.0 442.0 C372.3 426.7 379.7 418.0 387.0 406.0 Z';

/** Mark viewBox (both blades live in this user-space). */
export const MARK_VIEWBOX = '0 0 1254 1254';

/**
 * The same two blades, in a viewBox cropped to the INK.
 *
 * `MARK_VIEWBOX` is the vector's authored frame, and the blades occupy less
 * than half of it: measured from `getBBox()`, `x 331→921` and `y 281→912`, so
 * 47% of the width and 50% of the height. Two consequences follow, and both
 * read as bugs rather than as padding.
 *
 * A `<Logo size={28} />` draws a mark about **14px** across — so every caller
 * who picked a number by eye was compensating for empty space, and the mark
 * looks undersized beside type chosen for the box rather than for the ink.
 *
 * And the ink is not centred in that frame: its centre sits at
 * `626.51, 596.63` against a box centre of `627, 627`, i.e. **30 units high**,
 * 2.4% of the height. Flex-centring the ELEMENT therefore leaves the MARK
 * optically high next to a wordmark — the "off-centre" that no amount of
 * `items-center` fixes, because the box is centred correctly and the thing
 * inside it is not.
 *
 * Square, so a square `size` still yields a square box: the side is the taller
 * dimension (631) and the box is centred on the ink.
 */
export const MARK_VIEWBOX_TIGHT = '311.01 281.13 631 631';

/** Brand gradient stops (cyan→blue→violet), userSpaceOnUse x1=884 y1=296 x2=372 y2=908. */
export const GRADIENT_STOPS = [
  { offset: '0', color: '#16D2FF' },
  { offset: '0.27', color: '#1AA0FF' },
  { offset: '0.5', color: '#2B62FF' },
  { offset: '0.72', color: '#4326EE' },
  { offset: '0.9', color: '#7A18E8' },
  { offset: '1', color: '#B511E0' },
] as const;

/** Bright (adaptive / dark-UI) gradient stops — lifted edge so violet stays visible. */
export const GRADIENT_STOPS_BRIGHT = [
  { offset: '0', color: '#5fe3ff' },
  { offset: '0.27', color: '#46b6ff' },
  { offset: '0.5', color: '#5a86ff' },
  { offset: '0.72', color: '#7e5cff' },
  { offset: '0.9', color: '#ad5cff' },
  { offset: '1', color: '#d65cf0' },
] as const;

/** Linear-gradient geometry (userSpaceOnUse), shared by both stop sets. */
export const GRADIENT_GEOMETRY = { x1: '884', y1: '296', x2: '372', y2: '908' } as const;

/**
 * Badge fit transform — places the mark, centred, at 62% of a 100-unit tile.
 * Lifted verbatim from the design bundle's measured-bbox FIT string so the
 * squircle/coin badges match the prototype's silhouette exactly.
 */
export const BADGE_FIT_TRANSFORM = 'translate(50 50) scale(0.09830) translate(-626.51 -596.63)';

/** Badge tile viewBox. */
export const BADGE_VIEWBOX = '0 0 100 100';
